import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useState, useEffect } from "react";
import Buttons from "../components/Buttons";
import Navbar from "../components/Navbar";
import "./Home.css";

export default function Home() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [userName, setUserName] = useState<string>("");

  useEffect(() => {
    if (user) {
      // Estrae il nome dall'utente
      if (user.user_metadata?.full_name) {
        const firstName = user.user_metadata.full_name.split(" ")[0];
        setUserName(firstName);
      } else if (user.email) {
        const firstName = user.email.split("@")[0];
        setUserName(firstName);
      }
    }
  }, [user]);

  const handleAccediClick = () => {
    if (user) {
      // Se l'utente è loggato, vai direttamente a select-champion
      navigate("/select-champion");
    } else {
      // Altrimenti vai al login
      navigate("/login");
    }
  };

  const handleSbircialoClick = () => {
    navigate("/ranking");
  };

  return (
    <div className="home-container">
      <Navbar />

      {user && userName && (
        <div className="welcome-message">
          <h3 className="color-gradient">Ciao {userName}!</h3>
        </div>
      )}

      <div className="title">
        <h2 className="color-gradient2">Match Sponsor</h2>
      </div>

      <div className="promo-text">
        <h2 className="color-gradient">Fai canestro e conquista la</h2>
        <h3 className="color-gradient">vetta della classifica!</h3>
        <p>
          <b>Premi esclusivi</b> del Napoli Basket per i{" "}
          <b>primi 3 giocatori!</b>
        </p>
      </div>

      <div className="banner-premi">
        <img
          className="banner-img"
          src="/assets/banner-premi.png"
          alt="Banner Premi"
          width={500}
          height={500}
        />
      </div>

      <div className="terms">
        <a href="/termini">Termini e condizioni</a>
      </div>

      <Buttons
        onClickFirst={handleAccediClick}
        onClickSecond={handleSbircialoClick}
        textFirst={user ? "INIZIA" : "ACCEDI"}
        textSecond="SBIRCIA I PUNTEGGI"
      />
    </div>
  );
}
